/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import { configureStore } from "@reduxjs/toolkit";
import webSocketSlice from "../connection/websocket/websocketSlice";
import categoriesSlice from "../features/item-categories/itemCategoriesSlice";
import itemListSlice from "../features/item/item-list/itemListSlice";
import cartSlice from "../features/cart/CartSlice";
import asrSlice from "../features/asrText/asrSlice";
import ovSlice from "../features/bot-state/ovSlice";
import ttsSlice from "../features/ttsText/ttsSlice";
import webrtcSlice from "../connection/webrtc/webrtcSlice";
import postRoiEntrySlice from "../features/manage-roi/roiEntry";
import authorizationCodeSlice from "../session/AuthorizationCodeWrapper/authorizationCodeSlice";
import accessAndIdTokenSlice from "../session/AccessAndIdTokenWrapper/AccessAndIdTokenSlice";
import sessionSlice from "../session/sessionSlice";

const store = configureStore({
  reducer: {
    uuid: webSocketSlice.reducer,
    categories: categoriesSlice.reducer,
    itemList: itemListSlice.reducer,
    cart: cartSlice.reducer,
    asrState: asrSlice.reducer,
    ovState: ovSlice.reducer,
    ttsState: ttsSlice.reducer,
    session: sessionSlice.reducer,
    roiEntryStatus: postRoiEntrySlice.reducer,
    webrtcStatus: webrtcSlice.reducer,
    authorizationCodeState: authorizationCodeSlice.reducer,
    accessAndIdTokenState: accessAndIdTokenSlice.reducer,
  },
});

export default store;
